import Keycloak, { KeycloakInstance } from 'keycloak-js';
import { store } from '../store/store';
import {logout, setAuthenticated, setProvisioningTimedOut} from '../store/slices/authSlice';
import { KeycloakParsedToken } from '../types/token';
import { parseKeycloakToken } from './parseKeycloakToken';

let keycloakInstance: KeycloakInstance | null = null;

export const getKeycloakInstance = (): KeycloakInstance => {
    if (!keycloakInstance) {
        keycloakInstance = new (Keycloak as any)({
            url: process.env.REACT_APP_KEYCLOAK_URL,
            realm: process.env.REACT_APP_KEYCLOAK_REALM,
            clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
        }) as KeycloakInstance;
    }
    return keycloakInstance as KeycloakInstance;
};

export const initKeycloak = async (
    setKeycloakReady: (ready: boolean) => void
): Promise<void> => {
  const kc = getKeycloakInstance();

  try {
    const authenticated = await (kc as any).init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      pkceMethod: 'S256',
      // silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
      enableLogging: true,
      messageReceiveTimeout: 2000,
    });

    if (authenticated && kc.token && kc.tokenParsed) {
      const parsed = kc.tokenParsed as unknown as KeycloakParsedToken;

      const expiresSoon = parsed.exp * 1000 - Date.now() < 60_000;
      if (expiresSoon) {
        const refreshed = await kc.updateToken(0);
        if (!refreshed) {
          console.warn("Refresh failed. Logging out...");
          await kc.logout();
          return;
        }
      }

      // Push initial auth state
      store.dispatch(setAuthenticated({
        isAuthenticated: true,
        token: kc.token!,
        userInfo: parseKeycloakToken(parsed),
      }));

      setKeycloakReady(true);

      // If OpenStack isn't ready yet, poll until it is or timeout
      const initialOsReady = Boolean((kc.tokenParsed as any).os_ready);
      if (!initialOsReady) {
        store.dispatch(setProvisioningTimedOut(false));
        const startedAt = Date.now();
        const timeoutMs = 3 * 60 * 1000; // 3 minutes
        const intervalMs = 3000; // 3 seconds

        let ready = false;
        while (!ready && (Date.now() - startedAt) < timeoutMs) {
          try {
            // Force a refresh by requesting a very large minValidity
            const refreshed = await kc.updateToken(36000);
            if (refreshed && kc.token && kc.tokenParsed) {
              const userInfo = parseKeycloakToken(kc.tokenParsed as unknown as KeycloakParsedToken);
              store.dispatch(setAuthenticated({
                isAuthenticated: true,
                token: kc.token!,
                userInfo,
              }));
              ready = Boolean((kc.tokenParsed as any).os_ready);
              if (ready) {
                break;
              }
            }
          } catch (e) {
            // Continue polling silently; if session dies, onTokenExpired will handle
          }
          await new Promise(res => setTimeout(res, intervalMs));
        }
        if (!ready) {
          store.dispatch(setProvisioningTimedOut(true));
        }
      }
    } else {
      // store.dispatch(logout());
      // await kc.logout();
        console.log("not good!");
    }

    kc.onTokenExpired = async () => {
      try {
        const refreshed = await kc.updateToken(30);
        if (refreshed && kc.token && kc.tokenParsed) {
          store.dispatch(setAuthenticated({
            isAuthenticated: true,
            token: kc.token!,
            userInfo: parseKeycloakToken(kc.tokenParsed as unknown as KeycloakParsedToken),
          }));
        } else {
          store.dispatch(logout());
        }

      } catch (err) {
        console.error('Token auto-refresh failed, logging out:', err);
        store.dispatch(logout());
        await kc.logout();
      }
    };

  } catch (err) {
    console.error('initKeycloak failed:', err);
    throw err;
  }
};
